import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { getStoredRole, getTopNavLinks } from '../utils/navigation';

const C = { bg: '#0A0E1A', surface: '#111827', border: '#1F2937', accent: '#10B981', text: '#F9FAFB', muted: '#6B7280' };
const s = {
  page: { minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  topbar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 32px', borderBottom: `1px solid ${C.border}`, background: C.surface },
  logo: { fontSize: 20, fontWeight: 700, color: C.accent },
  nav: { display: 'flex', gap: 24, flexWrap: 'wrap' },
  navLink: (active) => ({ color: active ? C.accent : C.muted, textDecoration: 'none', fontSize: 14, fontWeight: active ? 700 : 400 }),
  main: { padding: 32, maxWidth: 1240, margin: '0 auto' },
  heading: { fontSize: 26, fontWeight: 700, marginBottom: 4 },
  sub: { fontSize: 14, color: C.muted, marginBottom: 24 },
  card: { background: C.surface, border: `1px solid ${C.border}`, borderRadius: 14, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', fontSize: 11, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.06em', padding: '12px 16px', borderBottom: `1px solid ${C.border}` },
  td: { padding: '12px 16px', fontSize: 13, borderBottom: `1px solid ${C.border}22` },
  empty: { textAlign: 'center', padding: '48px 0', color: C.muted }
};

export default function Plans() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', monthly_price: '', yearly_price: '', max_members: '', max_transactions_month: '' });
  const role = getStoredRole();
  const links = getTopNavLinks(role);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const r = await api.get('/superadmin/plans/data');
      setItems(Array.isArray(r.data) ? r.data : []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const createPlan = async () => {
    try {
      await api.post('/superadmin/plans', {
        name: form.name,
        monthly_price: form.monthly_price,
        yearly_price: form.yearly_price || null,
        max_members: form.max_members || null,
        max_transactions_month: form.max_transactions_month || null,
        has_wallet: true,
        has_payments: true,
      });
      setForm({ name: '', monthly_price: '', yearly_price: '', max_members: '', max_transactions_month: '' });
      setShowForm(false);
      await load();
    } catch (e) {
      alert(e?.response?.data?.error || 'No se pudo crear el plan');
    }
  };

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <div style={s.logo}>⚡ FintechCoop</div>
        <nav style={s.nav}>{links.map(link => <Link key={link.to} to={link.to} style={s.navLink(link.to === '/plans')}>{link.label}</Link>)}</nav>
      </div>
      <div style={s.main}>
        <div style={s.heading}>Planes</div>
        <div style={s.sub}>Catálogo de planes y límites de producto</div>
        <div style={{ marginBottom: 12 }}>
          {!showForm ? (
            <button onClick={() => setShowForm(true)}>Crear plan</button>
          ) : (
            <div style={{ display: 'grid', gap: 8, maxWidth: 520 }}>
              <input placeholder="Nombre" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input placeholder="Precio mensual" type="number" step="0.01" value={form.monthly_price} onChange={(e) => setForm({ ...form, monthly_price: e.target.value })} />
              <input placeholder="Precio anual" type="number" step="0.01" value={form.yearly_price} onChange={(e) => setForm({ ...form, yearly_price: e.target.value })} />
              <input placeholder="Max miembros" type="number" value={form.max_members} onChange={(e) => setForm({ ...form, max_members: e.target.value })} />
              <input placeholder="Max transacciones/mes" type="number" value={form.max_transactions_month} onChange={(e) => setForm({ ...form, max_transactions_month: e.target.value })} />
              <div>
                <button onClick={createPlan} style={{ marginRight: 8 }}>Guardar</button>
                <button onClick={() => setShowForm(false)}>Cancelar</button>
              </div>
            </div>
          )}
        </div>
        <div style={s.card}>
          {loading ? <div style={s.empty}>Cargando planes...</div> : items.length === 0 ? <div style={s.empty}>Sin datos disponibles</div> : (
            <table style={s.table}>
              <thead><tr>{['ID', 'Nombre', 'Precio mensual', 'Max miembros', 'Max tx/mes'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {items.map((p) => (
                  <tr key={p.id}>
                    <td style={s.td}>{p.id}</td>
                    <td style={s.td}>{p.name || '—'}</td>
                    <td style={s.td}>{p.price_monthly || '—'}</td>
                    <td style={s.td}>{p.max_members ?? '—'}</td>
                    <td style={s.td}>{p.max_transactions_per_month ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
